export default __webpack_public_path__ + "static/media/Recycling - Coral.8c84df70.svg";